export enum EExperienceSpaceRoute {
  Init = '/api/module/experience-space/init/:routeId'
}

export enum EFavouriteModulesRoute {
  IsFavourite     = '/api/module/favourite-modules/is-favourite',
  ToggleFavourite = '/api/module/favourite-modules/toggle-favourite',
  GetByUser       = '/api/module/favourite-modules/by-user'
}

export enum EAppDescriptionsRoute {
  GetStatus     = '/api/module/app-descriptions/get-status',
  GetByModuleId = '/api/module/app-descriptions/get-by-module-id/:moduleId'
}

export enum EStatusRoute {
  GetModuleEditorData             = '/api/module/admin/status/get-module-editor-data/:appId',
  SendLevelCombinations           = '/api/module/admin/status/send-level-combinations'
}

export enum EModuleFinderRoute {
  Search                = '/api/module/module-finder/search',
  SearchPreview         = '/api/module/module-finder/search-preview',
  GetLabels             = '/api/module/module-finder/get-labels'
}

export enum ELabelingRoute {
  Insert = '/api/module/admin/labeing/insert/:appId',
  Delete = '/api/module/admin/labeing/delete/:appId'
}

export enum ELevelOptionsRoute {
  Update                             = '/api/module/admin/level-options/update',
  GetActiveBySerial                  = '/api/module/level-options/active-by-serial/:serial',
  GetResourceStrings                 = '/api/module/level-options/get-resource-strings/:serial',
  GetById                            = '/api/module/admin/level-options/by-id/:id',
  GetByAppId                         = '/api/module/admin/level-options/by-app-id/:appId',
  DeleteById                         = '/api/module/admin/level-options/delete-by-id/:id',
  GetTranslatedLevelOptionsByAppId   = '/api/module/admin/level-options/get-translated-level-options-by-app-id/:appId',

  GetBySerialAndModuleId             = '/api/module/level-options/get-level-options', // Nem kell az 'admin' bele, mert kívülről is hívjuk.

  // Edus és simple engine-nel rendelkező appok számára.
  GetLevelOptionCombinationsBySerial = '/api/module/level-options/get-level-option-combinations-by-serial/:serial'
}

export enum ELabelsRoute {
  Insert            = '/api/module/admin/labels/insert',
  Update            = '/api/module/admin/labels/update/:id',
  GetById           = '/api/module/admin/labels/get-by-id/:id',
  DeleteById        = '/api/module/admin/labels/delete-by-id/:id',
  GetByType         = '/api/module/admin/labels/get-by-type/:labelType',
  GetParentSuitable = '/api/module/admin/labels/get-parent-suitable',
  GetEditorData     = '/api/module/admin/labels/get-editor-data',

  GetUsedThemes = '/api/module/labels/get-used-themes'
}

export enum EModulesRoute {
  DeleteById                      = '/api/module/admin/modules/delete-by-id',
  Get                             = '/api/modules/admin/modules',
  GetByAppId                      = '/api/modules/modules/get-by-app-id/:appId',
  GetById                         = '/api/module/admin/modules/get-by-id/:id',
  GetBySerialAndLevelOptions      = '/api/module/modules/by-serial-and-level-options/:serial',
  GetDetails                      = '/api/module/internal/modules/get-details',
  GetIdByAncientLevelOptions      = '/api/module/modules/get-id-by-ancient-level-options',
  GetInfos                        = '/api/module/internal/modules/get-infos',
  GetModuleCountInfo              = '/api/module/admin/modules/get-module-count-info',
  GetModuleableAppIds             = '/api/module/internal/modules/get-moduleable-app-ids',
  IsInLevelChecker                = '/api/module/internal/modules/is-in-level-checker/:id',
  ModularInit                     = '/api/module/modules/modular-init',
  Update                          = '/api/module/admin/modules/update/:id',
  GetRandomModulesByThemeAndGrade = '/api/module/get-random-modules-by-theme-and-grade',
  SetAvailabilities               = '/api/module/admin/set-availabilities',
  UpdateModuleDescription         = '/api/module/admin/module-description/update'
}

export enum ERoutesRoute {
  DeleteById                        = '/api/module/admin/routes/delete-by-id',
  Get                               = '/api/module/routes/get',
  GetById                           = '/api/module/admin/routes/get-by-id/:id',
  GetGradePeriods                   = '/api/module/admin/routes/get-grade-periods',
  GetLevelCheckerRouteFilters       = '/api/module/routes/get-level-checker-route-filters',
  GetMatchingLevelChecker           = '/api/module/routes/get-matching-level-checker',
  GetRoutesDetails                  = '/api/module/internal/routes/get-routes-details',
  GetDigestById                     = '/api/module/routes/get-digest-by-id/:id',
  Insert                            = '/api/module/admin/routes/insert',
  SetNotEditable                    = '/api/module/internal/routes/set-not-editable',
  CreateRouteByThemeAndGrade        = '/api/module/route-handling/create-route-by-theme-and-grade'
}

export enum ERouteLabelsRoute {
  GetAll      = '/api/module/route-labels/get-all',
  Insert      = '/api/module/admin/route-labels/insert',
  Update      = '/api/module/admin/route-labels/update',
  GetById     = '/api/module/admin/route-labels/get-by-id/:id',
  DeleteById  = '/api/module/admin/route-labels/delete-by-id/:id',
  GetByType   = '/api/module/admin/route-labels/get-by-type/:type',

  GetLevelCheckerInfos = '/api/module/internal/route-labels/get-level-checker-infos'
}

export enum EModuleImagesRoute {
  DeleteById        = '/api/module/admin/module-images/delete-by-id',
  InsertByUpload    = '/api/module/admin/module-images/insert-by-upload',
  InsertBase64Image = '/api/module/admin/module-images/insert-base64-image'
}

export enum EUserRoutesRoute {
  Get                = '/api/module/user-routes/get',
  Insert             = '/api/module/user-routes',
  Update             = '/api/module/user-routes/:id',
  Duplicate          = '/api/module/user-routes/duplicate/:routeId',
  DeleteByUserRoutes = '/api/module/user-routes/delete-by-user-routes'
}

export enum EWholeAppsRoute {
  InitFinder  = '/api/module/whole-apps/init-finder',
  Reset       = '/api/module/admin/whole-apps/reset',
  Search      = '/api/module/whole-apps/search'
}

export enum EGeneratedRoutesRoute {
  /** Az éppen bejelentkezett felhasználó generáltat új útvonalat.  */
  Generate = '/api/module/generated-routes/generate',
  /** Az éppen bejelentkezett felhasználó által generáltatott útvonalak lekérdezése.  */
  Get = '/api/module/generated-routes/by-user',
  /** Az úvonalösszerakónál felhasznált ajánlott modulok lekérdezése. */
  GenerateRecommendableModules = '/api/module/generated-routes/recommendations/:userIdentifier',
  /** Megmondja, hogy az éppen bejelentkezett felhasználó generált-e már útvonalat. */
  HasGenerated = '/api/module/generated-routes/has-generated',
  /** Elmenti és kiküldi a generált útvonalat az adott gyereknek. */
  SaveAndSend = '/api/module/generated-routes/save-and-send/:userIdentifier'
}
